export enum BreakpointSizes {
  IPHONE_SE = '(max-width: 320px) and (max-height: 568px)',
  IPHONE_6_7_8 = '(max-width: 375px) and (max-height: 667px)',
  IPHONE_PLUS = '(max-width: 414px) and (max-height: 736px)',
  IPHONE_X = '(max-width: 375px) and (max-height: 812px)',
  IPHONE_XR_XS_MAX = '(max-width: 414px) and (max-height: 896px)',
  IPHONE_12 = '(max-width: 390px) and (max-height: 844px)',
  IPHONE_12_PRO_MAX = '(max-width: 428px) and (max-height: 926px)',
  GALAXY_S = '(max-width: 360px) and (max-height: 740px)',
  PIXEL_6 = '(max-width: 412px) and (max-height: 915px)',

  // 📟 Landscape (Invertidos)
  IPHONE_SE_LANDSCAPE = '(max-width: 568px) and (max-height: 320px)',
  IPHONE_6_7_8_LANDSCAPE = '(max-width: 667px) and (max-height: 375px)',
  IPHONE_PLUS_LANDSCAPE = '(max-width: 736px) and (max-height: 414px)',
  IPHONE_X_LANDSCAPE = '(max-width: 812px) and (max-height: 375px)',
  IPHONE_XR_XS_MAX_LANDSCAPE = '(max-width: 896px) and (max-height: 414px)',
  IPHONE_12_LANDSCAPE = '(max-width: 844px) and (max-height: 390px)',
  IPHONE_12_PRO_MAX_LANDSCAPE = '(max-width: 926px) and (max-height: 428px)',
  GALAXY_S_LANDSCAPE = '(max-width: 740px) and (max-height: 360px)',
  PIXEL_6_LANDSCAPE = '(max-width: 915px) and (max-height: 412px)',
}

export const orderedBreakpoints: [BreakpointSizes, string][] = [
    [BreakpointSizes.IPHONE_SE, '12px'],
    [BreakpointSizes.IPHONE_6_7_8, '14px'],
    [BreakpointSizes.IPHONE_PLUS, '15px'],
    [BreakpointSizes.IPHONE_X, '16px'],
    [BreakpointSizes.IPHONE_XR_XS_MAX, '16px'],
    [BreakpointSizes.IPHONE_12, '17px'],
    [BreakpointSizes.IPHONE_12_PRO_MAX, '18px'],
    [BreakpointSizes.GALAXY_S, '14px'],
    [BreakpointSizes.PIXEL_6, '15px'],
  
    [BreakpointSizes.IPHONE_SE_LANDSCAPE, '13px'],
    [BreakpointSizes.IPHONE_6_7_8_LANDSCAPE, '14px'],
    [BreakpointSizes.IPHONE_PLUS_LANDSCAPE, '15px'],
    [BreakpointSizes.IPHONE_X_LANDSCAPE, '16px'],
    [BreakpointSizes.IPHONE_XR_XS_MAX_LANDSCAPE, '16px'],
    [BreakpointSizes.IPHONE_12_LANDSCAPE, '17px'],
    [BreakpointSizes.IPHONE_12_PRO_MAX_LANDSCAPE, '18px'],
    [BreakpointSizes.GALAXY_S_LANDSCAPE, '14px'],
    [BreakpointSizes.PIXEL_6_LANDSCAPE, '15px'],
  ];